import React from "react";
import PropTypes from "prop-types";
import CalculatorInput from "./CalculatorInput";
import CalculatorFeetInchesInput from "./CalculatorFeetInchesInput";

const HeightInputGroup = ({
  label = "Height",
  idPrefix,
  height,
  heightUnit,
  feet,
  inches,
  onHeightChange,
  onFeetChange,
  onInchesChange,
  onUnitChange,
  error,
  unitOptions,
  inputProps = {},
  isWebLayout = false,
  "data-testid": dataTestId,
}) => {
  const defaultInputProps = {
    type: "number",
    min: 0,
    autoComplete: "off",
    inputMode: "decimal",
    "data-testid": dataTestId,
    ...inputProps,
  };

  if (heightUnit === "in") {
    return (
      <CalculatorFeetInchesInput
        label={label}
        feetId={`${idPrefix}-height-feet`}
        inchesId={`${idPrefix}-height-inches`}
        feetValue={feet}
        inchesValue={inches}
        onFeetChange={onFeetChange}
        onInchesChange={onInchesChange}
        error={error}
        unitOptions={unitOptions}
        unitValue={heightUnit}
        onUnitChange={onUnitChange}
        isWebLayout={isWebLayout}
      />
    );
  }

  return (
    <CalculatorInput
      label={label}
      id={`${idPrefix}-height`}
      value={height}
      onChange={onHeightChange}
      error={error}
      unitOptions={unitOptions}
      unitValue={heightUnit}
      onUnitChange={onUnitChange}
      inputProps={defaultInputProps}
      isWebLayout={isWebLayout}
    />
  );
};

HeightInputGroup.propTypes = {
  label: PropTypes.string,
  idPrefix: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  heightUnit: PropTypes.string.isRequired,
  feet: PropTypes.string.isRequired,
  inches: PropTypes.string.isRequired,
  onHeightChange: PropTypes.func.isRequired,
  onFeetChange: PropTypes.func.isRequired,
  onInchesChange: PropTypes.func.isRequired,
  onUnitChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  unitOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      shortLabel: PropTypes.string,
    })
  ).isRequired,
  inputProps: PropTypes.object,
  isWebLayout: PropTypes.bool,
};

export default HeightInputGroup;
